import moment from 'moment';
import { getServiceTypes } from '../../HttpRequests/serviceTypes';
import { loadServiceTypes } from '../State/serviceTypes';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getServiceTypes();

    dispatch(loadServiceTypes(response.data.data));

  } catch (error) {
    
    throw error;

  }
}